export const showSuccess = (message: string, toast: any) => {
  toast.current?.show({
    severity: "success",
    summary: "Success",
    detail: message,
    life: 4000,
  });
};

export const showError = (message: string, toast: any, Heading?: string | null, toastLife?: number | null) => {
  toast.current?.show({
    severity: "error",
    summary: Heading ?? "",
    detail: message,
    life: toastLife ?? 4000,
  });
};

export const showWarning = (message: string, toast: any) => {
  toast.current?.show({
    severity: "warn",
    summary: "Warning",
    detail: message,
    life: 4000,
  });
};